export default __webpack_public_path__ + "static/media/video4.f6a837bd.png";